module.exports = __webpack_public_path__ + "static/kimiko-82f55ed2ca85a0b71249c8aaacb49a09.jpg";